import { createContext } from "react";

export const ObjectiveContentModalContext = createContext();
